import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, Grid, Paper, Tab } from '@mui/material';
import * as React from 'react';
import EntVistasView from '../../ent_vistas/EntVistasView';
import InformacionEntidadComponent from './components/InformacionEntidad';

const PanelEntidadView = () => {
  const [tab, setValue] = React.useState('1');

  const handleTabs = (event, newValue) => {
    setValue(newValue);
  };

  const tabs = [
    {
      id: '1',
      title: 'Vistas',
      component: <EntVistasView />,
    },
    // {
    //   id: '1',
    //   title: 'Suscripción',
    //   component: null,
    // },
  ];

  return (
    <Grid container spacing={1}>
      <Grid item md={4}>
        <InformacionEntidadComponent />
      </Grid>
      <Grid item md={8}>
        <Paper elevation={4}>
          <TabContext value={tab}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList
                onChange={handleTabs}
                aria-label="listado de vistas de la entidad"
              >
                {tabs.map((el) => {
                  return <Tab key={el.id} label={el.title} value={el.id} />;
                })}
              </TabList>
            </Box>
            {tabs.map((el) => {
              return (
                <TabPanel value={el.id} sx={{ p: 0, pt: 1 }}>
                  {el.component}
                </TabPanel>
              );
            })}
          </TabContext>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default PanelEntidadView;
